import React, { useEffect } from "react";
import Header from "../components/Header";
import HomeBanner from "../components/HomeBanner";
import DetailCard from "../components/DetailCard";
import Grid from "@mui/material/Grid";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getCurrentUserDetails } from "../services/api/users.api";
import { HomeBannerBackground } from "../components/styled/HomeBanner.styled";
import HomeTable from "../components/HomeTable";
import Footer from "../components/Footer";

function NewLandingHome() {
  const navigate = useNavigate();


  useEffect(() => {
    const getCurrentUser = async () => {
      try {
        await getCurrentUserDetails();
      } catch (err) {
        if (err.message === "No active account") {
          toast.error("Session Expired, Please Log back", {
            theme: "colored",
          });
          return navigate("/");
        }
      }
    };
    getCurrentUser();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Header />
      <HomeBanner small />
      <div style={{ marginTop: "100px" }}>
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item xs={3}>
            <DetailCard
              description="NaPA process involves from collecting
                    data, running geo marketing planning, performing network planning and provide 
                    recommendation to our customers."
              imagesrc="/assets/data_collection.png"
            />
          </Grid>
          <Grid item xs={3}>
            <DetailCard
              description="NaPA data sources include geodatasets, building layers, 
              population data, network data, market data & EDOTCO tower portfolio."
              imagesrc="/assets/tower.png"
            />
          </Grid>
          <Grid item xs={3}>
            <DetailCard
              description="To assess sites based on existing 
              EDOTCO footprint and new sites with colocation opportunity."
              imagesrc="/assets/server.png"
            />
          </Grid>
        </Grid>
      </div>
      <HomeTable/>
      <HomeBannerBackground />
      <Footer/>
    </>
  );
}

export default NewLandingHome;
